import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { AuditLogService } from '../../services/audit-log.service';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { CreateView } from '../../pages/school/global/create-view/create-view';
import { UpdateView } from '../../pages/school/global/update-view/update-view';
import { TimezonePipe } from '../../pipes/timezone.pipe';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-teacher-profile',
  standalone: true,
  imports: [CommonModule, NgbNavModule, CreateView, UpdateView, TimezonePipe, FormsModule],
  templateUrl: './teacher-profile.html',
  styleUrl: './teacher-profile.scss'
})
export class TeacherProfile {

  myListId: string | null = null;
  model: string = '';
  isLoading = false;

  myListData: any[] = [];     // all logs
  createData: any | null = null; // single CREATE
  updatesData: any[] = [];      // multiple UPDATE logs
  groupedLogs: { [key: string]: any[] } = {}; 
  activeTab = 1;

  constructor(
    private route: ActivatedRoute,
    private auditLogService: AuditLogService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.myListId = params['id'] || null;
      this.model = params['action'] || null;
      if (this.myListId) {
        this.fetchTeacherProfileLogs(this.myListId, this.model);
      }
    });
  }

  async fetchTeacherProfileLogs(id: string, action: string): Promise<void> {
    this.isLoading = true;
    try {
      const response: any = await firstValueFrom(
        this.auditLogService.searchById(id, action)
      );

      this.myListData = response?.data || [];
      this.createData = null;
      this.updatesData = [];

      // split into create + updates
      this.myListData.forEach((log: any) => {
        if (log.action === 'CREATE') {
          this.createData = log.new_fields;
        } else if (log.action === 'UPDATE') {
          this.updatesData.push(log);
        }
      });


      // group by object_id
      this.groupedLogs = this.groupBy(this.myListData, 'object_id');

      // sort + add version numbers
      Object.values(this.groupedLogs).forEach((logs: any[]) => {
        logs.sort((a, b) => {
          const aDate = a.action === 'UPDATE' ? new Date(a.updated_at) : new Date(a.created_at);
          const bDate = b.action === 'UPDATE' ? new Date(b.updated_at) : new Date(b.created_at);
          return bDate.getTime() - aDate.getTime();
        });

        let version = 1;
        logs.forEach(log => {
          if (log.action === 'UPDATE') {
            log.version = version++;
          }
          if (log._collapsed === undefined) {
            log._collapsed = false;
          }
        });
      });

    } catch (error) {
      console.error('Error during search:', error);
    } finally {
      this.isLoading = false;
    }
  }

  private groupBy(array: any[], key: string): { [key: string]: any[] } {
    return array.reduce((result, current) => {
      const groupKey = current[key] ?? 'unknown';
      if (!result[groupKey]) {
        result[groupKey] = [];
      }
      result[groupKey].push(current);
      return result;
    }, {} as { [key: string]: any[] });
  }

  onSearch(): void {
    if (this.myListId) {
      this.fetchTeacherProfileLogs(this.myListId.trim(), this.model);
    }
  }
}
